/**
 * 页面状态
 */
enum PageStatus {
  /**
   * 加载中
   */
  Loading,

  /**
   * 加载完成(有数据)
   */
  Complete,

  /**
   * 加载完成(无数据)
   */
  Nodata,

  /**
   * 加载失败
   */
  Error,

  /**
   * 活动未开始
   */
  ActivityNotStart,

  /**
   * 活动已结束
   */
  ActivityFinished,
}

export default PageStatus;
